export function getComponentHookClass(sysId: string): string {
  return sysId !== "" ? `cms-component-${sysId}` : "";
}
export function getComponentCMSClassname(sysId: string | undefined): string | undefined {
  return sysId ? getComponentHookClass(sysId) : undefined;
}
